import Link from 'next/link';
import Image from "next/image";

import styles from '@styles/dropAuction/howItWork.module.scss';
import {useApp} from '@context/AppProvider';

const StepThree = () => {
	const {convertCurrency} = useApp();
	return (
        <div className='col-sm-4'>
			<div className={styles.stepThree}>
				<div className={styles.stepBidBox}>
					<div className={styles.stepNumber}>3</div>
					<div className={styles.stepBidInner}>
						<span>You Won!</span>
						<div>
							<Image
                                width={270}
                                height={112}
                                src='https://s3.us-west-004.backblazeb2.com/betterthat/index/shoe-270x112.png'
                                alt='shoe'
                                style={{
                                    maxWidth: "100%",
                                    height: "auto"
                                }} />
						</div>
						<Link href='/' className={styles.wonTxt}>
                            For{convertCurrency(75)}
                        </Link>
					</div>
				</div>
				<div className={styles.stepText}>
					<h2>Win</h2>
					<p>
						Woohoo! If you have the winning bid we&apos;ll ship your item to
						your delivery address.
					</p>
				</div>
			</div>
		</div>
    );
};

export default StepThree;
